// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"26":"merchantOperation","78":"userGuide","673":"FAQ","877":"HowToUse"}[chunkId] + "." + {"26":"a9643ef4","78":"6eb0c3d8","673":"2964a74b","877":"0aabb264"}[chunkId] + ".js";
};